import React from 'react';
import SnackbarMessageCommon from './SnackbarMessageCommon';

const SnackbarMessage = ({ visible, message }) => {
    return (
        <SnackbarMessageCommon
            message={message}
            visible={visible}
        />
    );
};

export default SnackbarMessage;